import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "hooks/authentication/useAuth";
import LoginForm from "components/common/loginForm/LoginForm";
import { fetchProfile } from "services/FetchProfile";
import { usePermission } from "hooks/permission/usePermission";
const Login = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const auth = useAuth();
  const { setPermissions } = usePermission();
  const fetchUserProfile = async () => {
    const { route } = await fetchProfile(auth, setPermissions);
    if (route) {
      navigate(route);
    } else {
      setShow(true);
    }
  };
  useEffect(() => {
    // (() => {
    //   if (user) {
    //     navigate("/");
    //   } else {
    //     setShow(true);
    //   }
    // })();
    fetchUserProfile();
  }, []);

  return <div className="w-100">{show && <LoginForm />}</div>;
};

export default Login;
